<!-- use tags -->

import Layout1 from "../../src/routes/guide-examples/+layout.marko";
import Page from "../../src/routes/guide-examples/page-grid-pricing/+page.marko";

<Layout1>
	<Page/>
</>
